var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyndication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11393 3517)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11390.334 -3516.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.1,524.242h-6.4a4.02,4.02,0,0,1-4.015-4.015V510a4.02,4.02,0,0,1,4.015-4.015h6.4A4.02,4.02,0,0,1,627.114,510v10.225A4.02,4.02,0,0,1,623.1,524.242Zm-6.4-17.2A2.967,2.967,0,0,0,613.739,510v10.225a2.967,2.967,0,0,0,2.964,2.964h6.4a2.967,2.967,0,0,0,2.964-2.964V510a2.967,2.967,0,0,0-2.964-2.964Z",
    transform: "translate(-612.687 -505.986)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.727 13.504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.215,561.749a.526.526,0,0,1-.526-.526V557.88a.526.526,0,0,1,.526-.526h3.344a.526.526,0,1,1,0,1.052h-2.818v2.818A.526.526,0,0,1,650.215,561.749Z",
    transform: "translate(-649.689 -557.354)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.232 4.937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.422,530.18a.526.526,0,0,1-.517-.434,5,5,0,0,0-1.893-3,5.673,5.673,0,0,0-3.632-.9.526.526,0,0,1-.141-1.042,6.662,6.662,0,0,1,4.384,1.086,6.044,6.044,0,0,1,2.318,3.673.526.526,0,0,1-.426.609A.517.517,0,0,1,635.422,530.18Z",
    transform: "translate(-628.785 -524.768)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.019 7.224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.64,537.473a.526.526,0,0,1-.517-.434,3.208,3.208,0,0,0-1.215-1.925,3.679,3.679,0,0,0-2.341-.58.526.526,0,0,1-.14-1.042,4.694,4.694,0,0,1,3.092.767,4.271,4.271,0,0,1,1.639,2.6.526.526,0,0,1-.426.609A.552.552,0,0,1,632.64,537.473Z",
    transform: "translate(-627.973 -533.467)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.032 9.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.573,544.763a.526.526,0,0,1-.517-.435,1.3,1.3,0,0,0-.485-.769,1.521,1.521,0,0,0-.955-.236.526.526,0,0,1-.138-1.042,2.537,2.537,0,0,1,1.7.422,2.337,2.337,0,0,1,.91,1.442.526.526,0,0,1-.518.617Z",
    transform: "translate(-628.024 -542.266)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyndication);
export default __webpack_public_path__ + "static/media/Syndication.1b52f625fe7633708366156444fdf225.svg";
export { ForwardRef as ReactComponent };